<div *ngIf="loadAllSources"
    class="common__app compliance__body"
    id="compliance-app-template">
      <div class="common__view"
          id="compliance-view-body">
          <router-outlet></router-outlet>
      </div>
</div>
